const mediaItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20with%20dramatic%20night%20cityscape%2C%20noir%20detective%20silhouette%2C%20rain%20on%20windows%2C%20warm%20amber%20street%20lights%2C%20moody%20atmosphere%2C%20film%20grain%20texture%2C%20mysterious%20and%20suspenseful%20cinematography&width=800&height=450&seq=media-card-01&orientation=landscape",
    tag: '本周必看',
    title: '《暗夜追踪》终极预告',
    desc: '年度最受期待的悬疑动作片，揭开迷雾背后的真相',
    duration: '2:35',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20scene%20with%20futuristic%20city%2C%20warm%20golden%20hour%20lighting%2C%20floating%20structures%2C%20dreamy%20atmosphere%2C%20soft%20glow%2C%20film%20poster%20aesthetic%2C%20nostalgic%20and%20poetic%20visual&width=800&height=450&seq=media-card-02&orientation=landscape",
    tag: '影评人说',
    title: '《时光旅人》深度解析',
    desc: '穿越时空的情感史诗，每一帧都值得细细品味',
    duration: '8:20',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20movie%20production%20with%20film%20crew%20on%20arctic%20location%2C%20warm%20crimson%20and%20golden%20lighting%2C%20professional%20camera%20equipment%2C%20snowy%20mountain%20background%2C%20cinematic%20documentary%20style%2C%20adventure%20vibe&width=800&height=450&seq=media-card-03&orientation=landscape",
    tag: '幕后花絮',
    title: '《极地使命》拍摄现场',
    desc: '深入极寒之地，看主创团队如何挑战极限拍摄',
    duration: '5:12',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">精选预告</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">最新电影预告片与深度解析，抢先感受光影魅力</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <div key={item.title} className="group rounded-xl overflow-hidden bg-background-50 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-600 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/60 text-white text-xs rounded">{item.duration}</span>
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs rounded-md font-medium">{item.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-medium text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}